import MonthlyReportingGridComponent from './monthly-reporting-grid-component'
import MonthlyReportingRow from '../monthly-reporting-row/monthly-reporting-row';

/***
 * A reusable component that allows you to display series of rows with metadata about a client (client name, country,
 * campus, facility, etc.) as well as a grid of 12 boxes, one for each month, that track whether some sort of
 * reporting data has been entered for that month or not. Completed months can open a popover with links to
 * Jasper reports.
 */
const monthlyReportingGrid = angular
    .module('FacilityData.MonthlyReporting.MonthlyReportingGrid', [
        MonthlyReportingRow
    ])
    .component('monthlyReportingGrid', MonthlyReportingGridComponent)
    .name;

export default monthlyReportingGrid;


// WEBPACK FOOTER //
// ./app/common/monthly-reporting/monthly-reporting-grid/monthly-reporting-grid.js